export const Theme = {
  space: {
    large: "1600px",
    medio: "1200px",
  },
};
